$(".filter__toggle").click(function () {
    $(this).parents(".filter__group").toggleClass("_active")
    $(this).parents(".filter__group").find(".filter__hidden").slideToggle()
})

$(".catalog__show-filter").click(function () {
    $(".filter").addClass("_open")
    $("body").addClass("fixed-body")
})

$(".filter__bg").click(function () {
    $(".filter").removeClass("_open")
    $("body").removeClass("fixed-body")
})

$(document).on('click', '.rating-input__item', function(e) {
    let ratingItem = parseInt($(this).attr("data-rating-value"))
    $(this).parent(".rating-input").attr("data-total-rating", ratingItem)
    $(this).siblings(".rating-input__field").val(ratingItem)
})

$(".rating-input__item").click(function() {
    // let ratingItem = parseInt($(this).attr("data-rating-value"))
    // $(this).parent(".rating-input").attr("data-total-rating", ratingItem)
    // $(this).siblings(".rating-input__field").val(ratingItem)
})

$(".product-props__link").click(function () {
    $(".product-props__link").removeClass("_active")
    $(this).addClass("_active")
})

$("._show-share").click(function () {
    $(".share").toggleClass("_active")
})

$(document).mouseup(function(e) {
    var div = $('.share');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).addClass("_active")){
            $(div).removeClass("_active")
        }
    }
});

$(".mode-card").click(function () {
    $(".mode-card").removeClass("_active")
    $(this).addClass("_active")
})

$(document).mouseup(function(e) {
    var div = $('.mode-card');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).addClass("_active")){
            $(div).removeClass("_active")
        }
    }
});

let videoBanner = document.querySelectorAll(".header-card__img video")
videoBanner.forEach(video => {
    console.log(video)
    video.load();
})
